import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import generalStyle from "../../styles";

export const CheckBoxContainer = ({ optionsLeft, optionsRight, text }) => {
  const checkBoxBlock = StyleSheet.create({
    optionNotSelected: {
      width: 15,
      height: 15,
      backgroundColor: "white",
      border: "1 solid black",
    },
    text: {
      fontSize: 10,
    },
    optionText: {
      fontSize: 10,
      marginRight: 4,
    },
    optionWrapper: {
      ...generalStyle.inLineBlocks,
      marginRight: 16,
    },
    optionWrapperLeft: {
      ...generalStyle.inLineBlocks,
      marginRight: 8,
    },
    container: {
      ...generalStyle.inLineBlocks,
      marginTop: 7,
    },
  });

  return (
    <View data-testid="checkbox-container" style={checkBoxBlock.container}>
      {optionsLeft?.map((option, index) => (
        <View key={index} style={checkBoxBlock.optionWrapperLeft}>
          {option ? (
            <Text style={checkBoxBlock.optionText}>{option}</Text>
          ) : null}
          <View style={checkBoxBlock.optionNotSelected} />
        </View>
      ))}
      <Text style={checkBoxBlock.text}>{text}</Text>
      {optionsRight?.map((option, index) => (
        <View key={index} style={checkBoxBlock.optionWrapper}>
          <Text style={checkBoxBlock.optionText}>{option}</Text>
          <View style={checkBoxBlock.optionNotSelected} />
        </View>
      ))}
    </View>
  );
};
